import changeModule from '../actions/changeModule.js'
import changeServerModule from '../actions/changeServerModule.js'

export default [
  changeServerModule,
  { success: [changeModule], error: [changeModule] }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/changeModule.js